import { render } from "./FreemiumWelcomeDialog.vue?vue&type=template&id=a50917c0&scoped=true"
import script from "./FreemiumWelcomeDialog.vue?vue&type=script&lang=js"
export * from "./FreemiumWelcomeDialog.vue?vue&type=script&lang=js"

import "./FreemiumWelcomeDialog.vue?vue&type=style&index=0&id=a50917c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50917c0"]])

export default __exports__